/**
 * Auth and auth-adjacent keys use sessionStorage so each browser tab has its own
 * session. localStorage is shared across tabs, so logging in as a second role
 * in another tab would overwrite the first account's token.
 *
 * UI preferences (e.g. admin sidebar) can stay on localStorage in those components.
 */

const S = typeof window !== "undefined" ? window.sessionStorage : null;

function getStorage() {
  return S;
}

let legacyLocalStorageMigrated = false;

/** One-time copy of token/user from localStorage (old builds) into this tab's sessionStorage */
function migrateLegacyLocalStorageOnce() {
  if (legacyLocalStorageMigrated || typeof window === "undefined") return;
  legacyLocalStorageMigrated = true;
  try {
    const st = window.sessionStorage;
    const loc = window.localStorage;
    if (!st || !loc) return;
    if (st.getItem("token")) return;
    const token = loc.getItem("token");
    const user = loc.getItem("user");
    if (token) {
      st.setItem("token", token);
      loc.removeItem("token");
    }
    if (user) {
      st.setItem("user", user);
      loc.removeItem("user");
    }
  } catch {
    /* private mode / quota */
  }
}

export function authStorageGet(key) {
  migrateLegacyLocalStorageOnce();
  try {
    return getStorage()?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function authStorageSet(key, value) {
  try {
    getStorage()?.setItem(key, value);
  } catch {
    /* ignore quota / private mode */
  }
}

export function authStorageRemove(key) {
  try {
    getStorage()?.removeItem(key);
  } catch {
    /* ignore */
  }
}

/** Keys written by login / signup / wallet linking — cleared on signOut */
const SESSION_AUTH_KEYS = [
  "token",
  "user",
  "signupUserId",
  "signupRole",
  "investor_wallet_address",
  "investor_wallet_provider",
  "userId",
];

export function clearAuthSessionStorage() {
  const st = getStorage();
  if (!st) return;
  try {
    SESSION_AUTH_KEYS.forEach((k) => st.removeItem(k));
  } catch {
    /* ignore */
  }
}
